import { api } from "./api";

export const isIOS = () => /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
export const isPhone = () => window.matchMedia("(pointer: coarse)").matches && Math.min(window.screen.width, window.screen.height) < 820;
export const isStandalone = () => window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
export const pushSupported = () => "serviceWorker" in navigator && "PushManager" in window && "Notification" in window && (!isIOS() || isStandalone());

const toKey = (v) => { const p = "=".repeat((4 - (v.length % 4)) % 4); return Uint8Array.from(atob((v + p).replace(/-/g, "+").replace(/_/g, "/")), (c) => c.charCodeAt(0)); };
const reg = () => navigator.serviceWorker.register("/sw.js").then(() => navigator.serviceWorker.ready);

export async function currentSub() {
  if (!pushSupported()) return null;
  return (await reg()).pushManager.getSubscription();
}

export async function enablePush() {
  if ((await Notification.requestPermission()) !== "granted") throw new Error("Alerts were blocked. You can allow them in your phone's settings for this app.");
  const r = await reg();
  const { data } = await api.get("/push/key");
  let sub;
  try {
    sub = (await r.pushManager.getSubscription()) || (await r.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: toKey(data.key) }));
  } catch (_) {
    throw new Error("This browser couldn't turn on alerts. Try again from the Workplace app on your home screen.");
  }
  await api.post("/push/subscribe", sub.toJSON());
  return sub;
}

export async function disablePush() {
  const sub = await currentSub();
  if (!sub) return;
  await api.post("/push/unsubscribe", { endpoint: sub.endpoint });
  await sub.unsubscribe();
}
